var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "video__player__controls stick-all-corners\n    d-flex justify-content-center align-items-center\n  ",
      class: _vm.visible ? "controls--visible" : "",
      on: {
        click: _vm.onClick,
        mouseleave: _vm.onMouseleave,
        mousemove: _vm.throttled.onMousemove
      }
    },
    [
      _c("ControlOverlay", {
        ref: "controlOverlayWrapper",
        attrs: {
          player: _vm.player,
          "control-active": _vm.visible,
          "data-ui-section": "overlay"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "controlBarWrapper",
          staticClass: "control-bar-wrapper stick-bottom-left w-100",
          class: [
            _vm.visible ? "expanded" : "",
            "control-bar-wrapper--state--" + _vm.videoPlayerStoreState.state
          ]
        },
        [
          _c("ControlBar", {
            ref: "controlBar",
            attrs: {
              player: _vm.player,
              "control-active": _vm.visible,
              "data-ui-section": "bar"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }